// extracted by mini-css-extract-plugin
export var activityContainer = "_nb-0";
export var typingIndicatorContainer = "_nb-1";
export var typingIndicatorDot = "_nb-2";
export var wave = "_nb-3";